import React from "react";
import { useNavigate } from "react-router-dom";
import { Radar, LayoutDashboard, Inbox, ArrowRight, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import ThemeToggle from "../components/ThemeToggle";

const SelectPortal = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const cards = [
    { key: "admin", to: "/dashboard", icon: LayoutDashboard, title: "Admin Console",
      desc: "Manage clients, subscription, approvals and firm-wide activity.", color: "#2f2b8f" },
    { key: "employee", to: "/employee", icon: Inbox, title: "Request Center",
      desc: "Your command center — track requests, review documents and act on client submissions.", color: "#0d9488" },
  ];

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-6 py-5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#2f2b8f]"><Radar className="h-5 w-5 text-white" /></div>
          <span className="text-lg font-bold text-[#1a1a2e] dark:text-slate-100">Files on Radar</span>
        </div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <button data-testid="portal-logout" onClick={() => { logout(); navigate("/"); }} className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300">
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 pt-16">
        <p className="text-sm font-semibold uppercase tracking-wide text-[#2f2b8f] dark:text-indigo-400">Welcome back, {user?.name?.split(" ")[0]}</p>
        <h1 className="mt-2 text-3xl font-bold text-[#1a1a2e] dark:text-slate-100 sm:text-4xl">Choose your workspace</h1>
        <p className="mt-2 text-slate-500 dark:text-slate-400">You can switch anytime from the header toggle.</p>
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {cards.map((c) => (
            <button key={c.key} data-testid={`portal-card-${c.key}`} onClick={() => navigate(c.to)}
              className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-7 text-left shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg dark:border-slate-800 dark:bg-slate-900">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${c.color}15` }}>
                <c.icon className="h-6 w-6" style={{ color: c.color }} />
              </div>
              <h2 className="mt-5 text-lg font-bold text-[#1a1a2e] dark:text-slate-100">{c.title}</h2>
              <p className="mt-1.5 flex-1 text-sm text-slate-500 dark:text-slate-400">{c.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: c.color }}>
                Enter <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SelectPortal;
